import {
    BRANCH_CREATE,
    BRANCH_FAILED, BRANCH_HIDE_MODAL,
    BRANCH_LOAD,
    BRANCH_LOADING, BRANCH_SHOW_MODAL,
    BRANCH_SUCCESS, BRANCH_UPDATE, HIDE_MODAL,
    SHOW_MODAL
} from "../constants/BranchConst";


const initState = {
    loading     : false,
    message     : '',
    showMessage : false,
    modal       : false,
    page        : 1,
    total       : 0,
    data        : []
}

const branchreducer = (state = initState, action) => {
    switch (action.type) {
        case BRANCH_LOADING:
            return {
                ...state,
                loading: true,
            }
        case BRANCH_SHOW_MODAL:
            return {
                ...state,
                modal: true,
            }
        case BRANCH_HIDE_MODAL:
            return {
                ...state,
                modal: false,
            }
        case BRANCH_FAILED:
            return {
                ...state,
                message: action.message,
                showMessage: true,
                loading: false
            }
        case BRANCH_SUCCESS:
            return {
                ...state,
                showMessage: false,
                data:action.data,
                loading: false,
                modal: false,
            }
        case BRANCH_LOAD:
            return {
                ...state,
                page: action.page,
                loading: true,
            }
        case BRANCH_CREATE:
            return {
                ...state,
                loading: true,
            }
            case BRANCH_UPDATE:
            return {
                ...state,
                loading: true,
            }

        default:
            return state;
    }
}

export default branchreducer